import { render, staticRenderFns } from "./AnalysisCardOld.vue?vue&type=template&id=281e39c0&scoped=true&"
import script from "./AnalysisCardOld.vue?vue&type=script&lang=js&"
export * from "./AnalysisCardOld.vue?vue&type=script&lang=js&"
import style0 from "./AnalysisCardOld.vue?vue&type=style&index=0&id=281e39c0&prod&scoped=true&lang=css&"
import style1 from "./AnalysisCardOld.vue?vue&type=style&index=1&id=281e39c0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281e39c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
